import {AdditionalHeadLinkAttributes} from './additional-head-link-attributes';

export class HeadLink {

  name: string;
  url: string;
  additionalAttributes?: AdditionalHeadLinkAttributes[];
}
